import { baseApi } from './baseApi';

export const vendorApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getVendors: builder.query({
      query: () => '/api/vendors',
      providesTags: ['Vendors'],
    }),
  }),
});

export const { useGetVendorsQuery } = vendorApi;
